





















import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import InfoTooltip from '@/UI/Shared/InfoTooltip.vue'
import {
  FetchProcedureWithPresentedDocumentationCommand
} from '@/Application/Documentation/Presented'
import {
  FetchProcedureWithPresentedDocumentationCommandHandlerProvider
} from '@/Infrastructure/Documentation/Presented/Provider'

export default Vue.extend({
  name: 'AlreadyPresentedSelector',
  components: { Multiselect, InfoTooltip },
  props: {
    documentTypeId: {
      type: Number,
      required: true
    },
    applicantNif: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      options: [] as string[],
      currentOption: ''
    }
  },
  computed: {
    id (): string {
      return 'already-presented-selector-' + this.documentTypeId
    }
  },
  mounted (): void {
    this.loadProcedureCodes()
  },
  methods: {
    onProcedureSelected ($event: string) {
      const parsedData = {
        procedure: '',
        year: ''
      }
      if ($event) {
        const splittedData = $event.split('-')
        const yearSelected = splittedData[2]
        parsedData.procedure = $event
        parsedData.year = yearSelected
      }
      this.$emit('procedure-selected', parsedData)
    },
    loadProcedureCodes (): void {
      const command = new FetchProcedureWithPresentedDocumentationCommand(
        this.applicantNif,
        this.documentTypeId
      )
      this.loading = true
      const provider = new FetchProcedureWithPresentedDocumentationCommandHandlerProvider()
      const handler = provider.provide()
      handler.handle(command)
        .then(procedureCodes => {
          this.options = procedureCodes
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
})
